import styled from 'styled-components';
import Colors from 'shared/styles/colors';

const ShopWrapper = styled.div`
  padding: 200px 20px 0 20px;
  max-width: 1480px;
  margin: 0 auto;
  min-height: 100vh;
`

const ShopHeader = styled.h1`
  text-align: center;
  font-weight: 700;
  background: rgb(48,59,113);
  background: linear-gradient(135deg, #2C3E50 0%, #7F8C8D 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  max-width: 235px;
  margin: 0 auto;
  padding: 10px;
  border-radius: 10px;
  color: ${Colors.white};
  pointer-events: none;
  user-select: none;
`

const ShopContent = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  justify-items: center;
  
    @media (max-width: 630px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 430px) {
      grid-template-columns: repeat(1, 1fr);
    }
`

const ShopItem = styled.div`
  background-color: ${Colors.white};
  width: 350px;
  max-width: 350px;
  border-radius: 6px;
`

const ShopItemTitle = styled.h2`
  font-weight: 700;
`

const ShopItemAuthor = styled.span `
  display: flex;
    svg {
      margin-right: 4px;
    }
`

const ShopItemLower = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
`

const ShopItemPrice = styled.p`
  display: flex;
  justify-content: flex-end;
  color: rgb(95 141 79);
  font-weight: 600;
`

const ShopItemDescription = styled.p`
  margin-top: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-height: 19px;
`

const ShopContainer = styled.section`
  padding: 10px;
`
const ImageContainer = styled.section`
  border-radius: 6px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      border-radius: 6px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      user-select: none;
    }
`
const ShopItemButtonContainer = styled.section`
  display: flex;
  width: 100%;
  align-items: flex-end;
    button {
      width: 100%;
    }
`

export default {
  ShopWrapper,
  ShopHeader,
  ShopContent,
  ShopItem,
  ImageContainer,
  ShopItemTitle,
  ShopItemPrice,
  ShopItemDescription,
  ShopContainer,
  ShopItemButtonContainer,
  ShopItemLower,
  ShopItemAuthor,
}